<template>
    <div>
        <template v-if="isCreatable">
            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                {{ $t('DATEV-Export') }}
            </h3>
            <div
                class="kgr-alert kgr-alert--info kgr-row"
            >
                {{ $t('club.datevExports.infoText') }}
            </div>
            <kgr-form-row
                :label="$t('Leistungszeitraum')"
                :error="error"
                field-name="invoicePeriod"
            >
                <label
                    class="kgr-radio kgr-radio--inline"
                    @click="optionSingle"
                >
                    <input
                        type="radio"
                        :checked="isSingle"
                        class="kgr-radio__control"
                    />
                    <span class="kgr-radio__label">{{ $t('Monatsweise exportieren') }}</span>
                </label>
                <label
                    class="kgr-radio kgr-radio--inline"
                    @click="optionFull"
                >
                    <input
                        type="radio"
                        :checked="isFull"
                        class="kgr-radio__control"
                    />
                    <span
                        class="kgr-radio__label"
                    >{{ $t('Alle noch nicht exportierten Buchungen') }}</span>
                </label>
                <label
                    class="kgr-radio kgr-radio--inline"
                    @click="optionRange"
                >
                    <input
                        type="radio"
                        :checked="isRange"
                        class="kgr-radio__control"
                    />
                    <span
                        class="kgr-radio__label"
                    >{{ $t('Leistungszeitraum frei definierbar') }}</span>
                </label>
            </kgr-form-row>

            <div
                v-if="isSingle"
                class="datePickers"
            >
                <kgr-dropdown
                    v-model="invoicePeriodSingleMonth"
                    :options="convertedInvoiceMonths"
                    :inline="true"
                    display="month"
                />
                <kgr-dropdown
                    v-model="invoicePeriodSingleYear"
                    :options="convertedInvoiceYears"
                    :inline="true"
                    display="year"
                />
            </div>
            <div
                v-if="isRange"
                class="datePickers"
            >
                <kgr-dropdown
                    v-model="invoicePeriodRangeStartMonth"
                    :options="convertedInvoiceMonths"
                    :inline="true"
                    :label="$t('Von')"
                    display="month"
                />
                <kgr-dropdown
                    v-model="invoicePeriodRangeStartYear"
                    :options="convertedInvoiceYears"
                    :inline="true"
                    display="year"
                />
                <kgr-dropdown
                    v-model="invoicePeriodRangeEndMonth"
                    :options="convertedInvoiceMonths"
                    :inline="true"
                    :label="$t('Bis')"
                    display="month"
                />
                <kgr-dropdown
                    v-model="invoicePeriodRangeEndYear"
                    :options="convertedInvoiceYears"
                    :inline="true"
                    display="year"
                />
            </div>

            <kgr-form-row
                :label="$t('Bebuchbare Perioden')"
                :error="error"
                field-name="bookingPeriod"
            >
                <kgr-dropdown
                    v-model="selectedBookingPeriod"
                    :options="convertedBookingPeriods"
                    display="period"
                />
            </kgr-form-row>

            <kgr-button
                :value="$t('Export starten')"
                :disabled="buttonDisabled"
                :pending="pending"
                @click="createExport()"
            />

            <div v-if="showRunningExport">
                <hr class="kgr-separator kgr-separator--light" />
                <h3 class="kgr-headline kgr-headline--h3">
                    {{ $t('Laufender Export') }}
                </h3>
                <table class="kgr-table kgr-table--block data-table table-groups printable">
                    <thead>
                        <tr class="kgr-table__row">
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Buchungsperiode') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Leistungszeitraum') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Status') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="job in jobMetaClub"
                            class="kgr-table__row row-top is-striped"
                        >
                            <td>{{ job.bookingPeriod }}</td>
                            <td>{{ job.invoicePeriodStart }} - {{ job.invoicePeriodEnd }}</td>
                            <td>
                                <i
                                    class="icon-refresh icon-spin"
                                    :title="$t('Der Export wird im Hintergrund erstellt')"
                                ></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>

        <hr class="kgr-separator kgr-separator--light" />
        <h3 class="kgr-headline kgr-headline--h3">
            {{ $t('DATEV-Exporte') }}
        </h3>
        <table
            class="kgr-table kgr-table--block data-table table-groups printable"
            :searching="false"
        >
            <thead>
                <tr class="kgr-table__row">
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Buchungsperiode') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Leistungszeitraum') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Datei') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Erstellt am') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-if="datevExports.length === 0"
                    class="kgr-table__row row-top"
                >
                    <td colspan="4">
                        {{ $t('Es sind keine Exporte vorhanden') }}
                    </td>
                </tr>
                <tr
                    v-for="(datevExport, index) in datevExports"
                    class="kgr-table__row row-top"
                    :class="{ 'is-striped': index % 2 === 0 }"
                >
                    <td>{{ datevExport.bookingPeriod }}</td>
                    <td>{{ datevExport.formattedInvoicePeriod }}</td>
                    <td>
                        <a
                            class="kgr-link kgr-link--unobtrusive"
                            :title="$t('Export herunterladen')"
                            @click="download(datevExport.id)"
                        >
                            {{ datevExport.attachmentName }}
                        </a>
                    </td>
                    <td>{{ datevExport.formattedCreatedAt }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Dropdown from '../common/form/select/Dropdown';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';
import KgrButton from '../common/form/button/KgrButton';
import axios from 'axios';

const SINGLE = 'single';
const FULL = 'full';
const RANGE = 'range';
const RANGE_MINUS_MONTHS = 2;

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-button': KgrButton,
        'kgr-dropdown': Dropdown,
    },
    props: {
        datevExports: {
            type: Array,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        pending: {
            type: Boolean,
            required: true,
        },
        jobMetaClub: {
            type: Array,
            required: true,
        },
        startYear: {
            type: String,
            required: true,
        },
        invoiceMonths: {
            type: Object,
            required: true,
        },
        invoiceYears: {
            type: Object,
            required: true,
        },
        bookingPeriods: {
            type: Object,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            selectedBookingPeriod: null,
            invoicePeriodRange: null,
            invoicePeriodSingleMonth: null,
            invoicePeriodSingleYear: null,
            invoicePeriodFullStartMonth: null,
            invoicePeriodFullStartYear: null,
            invoicePeriodFullEndMonth: null,
            invoicePeriodFullEndYear: null,
            invoicePeriodRangeStartMonth: null,
            invoicePeriodRangeStartYear: null,
            invoicePeriodRangeEndMonth: null,
            invoicePeriodRangeEndYear: null,
            invoicePeriodSingleInitiated: false,
            invoicePeriodFullInitiated: false,
            invoicePeriodRangeInitiated: false,
            convertedInvoiceMonths: this.convertInvoiceMonths(),
            convertedInvoiceYears: this.convertInvoiceYears(),
            convertedBookingPeriods: this.convertBookingPeriods(),
        };
    },
    computed: {
        buttonDisabled() {
            return this.pending
                || this.jobMetaClub.length > 0
                || this.selectedBookingPeriod === null
                || !this.hasInvoicePeriod;
        },
        hasInvoicePeriod() {
            return (this.isSingle && this.invoicePeriodSingleMonth !== null && this.invoicePeriodSingleYear !== null)
                || (this.isFull && this.invoicePeriodFullStartMonth !== null && this.invoicePeriodFullStartYear !== null
                    && this.invoicePeriodFullEndMonth !== null && this.invoicePeriodFullEndYear !== null)
                || (this.isRange && this.invoicePeriodRangeStartMonth !== null && this.invoicePeriodRangeStartYear !== null
                    && this.invoicePeriodRangeEndMonth !== null && this.invoicePeriodRangeEndYear !== null);
        },
        isSingle() {
            return this.invoicePeriodRange === SINGLE;
        },
        isFull() {
            return this.invoicePeriodRange === FULL;
        },
        isRange() {
            return this.invoicePeriodRange === RANGE;
        },
        showRunningExport() {
            return this.jobMetaClub.length > 0;
        },
    },
    mounted() {
        this.selectedBookingPeriod = this.getCurrentBookingPeriod();
        this.optionSingle();
        this.$emit('init');
    },
    methods: {
        convertInvoiceMonths() {
            const months = [];
            for (const [key, month] of Object.entries(this.invoiceMonths)) {
                months.push({ key, month });
            }
            return months;
        },
        convertInvoiceYears() {
            const years = [];
            for (const [key, year] of Object.entries(this.invoiceYears)) {
                years.push({ key, year });
            }
            return years;
        },
        convertBookingPeriods() {
            const periods = [];
            for (const [key, period] of Object.entries(this.bookingPeriods)) {
                periods.push({ key, period });
            }
            return periods;
        },
        createExport() {
            if (this.buttonDisabled) {
                return;
            }
            let invoicePeriodDateStrings = null;
            if (this.isSingle) {
                invoicePeriodDateStrings = this.getSingleDateStrings();
            } else if (this.isFull) {
                invoicePeriodDateStrings = this.getFullDateStrings();
            } else if (this.isRange) {
                invoicePeriodDateStrings = this.getRangeDateStrings();
            }
            const bookingPeriodSplit = this.selectedBookingPeriod.key.split('-');
            const emitData = {
                start: invoicePeriodDateStrings !== null ? invoicePeriodDateStrings[0] : null,
                end: invoicePeriodDateStrings !== null ? invoicePeriodDateStrings[1] : null,
                month: bookingPeriodSplit[1],
                year: bookingPeriodSplit[0],
            };
            this.$emit('create', emitData);
        },
        getSingleDateStrings() {
            const startDate = new Date(this.invoicePeriodSingleYear.key, this.invoicePeriodSingleMonth.key - 1, 1);
            const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
            return this.getDateStrings(startDate, endDate);
        },
        getFullDateStrings() {
            const startDate = new Date(this.invoicePeriodFullStartYear.key, this.invoicePeriodFullStartMonth.key - 1, 1);
            const endDate = new Date(this.invoicePeriodFullEndYear.key, this.invoicePeriodFullEndMonth.key, 0);
            return this.getDateStrings(startDate, endDate);
        },
        getRangeDateStrings() {
            const startDate = new Date(this.invoicePeriodRangeStartYear.key, this.invoicePeriodRangeStartMonth.key - 1, 1);
            const endDate = new Date(this.invoicePeriodRangeEndYear.key, this.invoicePeriodRangeEndMonth.key, 0);
            return this.getDateStrings(startDate, endDate);
        },
        getDateStrings(startDate, endDate) {
            let startMonth = startDate.getMonth() + 1;
            if (startMonth < 10) {
                startMonth = `0${startMonth}`;
            }
            let endMonth = endDate.getMonth() + 1;
            if (endMonth < 10) {
                endMonth = `0${endMonth}`;
            }
            return [
                `${startDate.getFullYear()}-${startMonth}-01`,
                `${endDate.getFullYear()}-${endMonth}-${endDate.getDate()}`,
            ];
        },
        download(exportLogId) {
            const url = `/club/clubs/${this.clubId}/financial-accounting/datev-exports/download/${exportLogId}`;
            axios
                .get(url, { responseType: 'blob' })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const filename = this.getFilenameFromHeaders(response.headers);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });
        },
        getFilenameFromHeaders(headers) {
            const headerLine = headers['content-disposition'];
            const startFileNameIndex = headerLine.indexOf('"') + 1;
            const endFileNameIndex = headerLine.lastIndexOf('"');
            return headerLine.substring(startFileNameIndex, endFileNameIndex);
        },
        optionSingle() {
            this.invoicePeriodRange = SINGLE;
            if (!this.invoicePeriodSingleInitiated) {
                this.invoicePeriodSingleMonth = this.getCurrentInvoiceMonth();
                this.invoicePeriodSingleYear = this.getCurrentInvoiceYear();
                this.invoicePeriodSingleInitiated = true;
            }
        },
        optionFull() {
            this.invoicePeriodRange = FULL;
            if (!this.invoicePeriodFullInitiated) {
                this.invoicePeriodFullStartMonth = this.getEntryFromObjectArray(this.convertedInvoiceMonths, '1');
                this.invoicePeriodFullStartYear = this.getEntryFromObjectArray(this.convertedInvoiceYears, this.startYear.toString());
                this.invoicePeriodFullEndMonth = this.getCurrentInvoiceMonth();
                this.invoicePeriodFullEndYear = this.getCurrentInvoiceYear();
                this.invoicePeriodFullInitiated = true;
            }
        },
        optionRange() {
            this.invoicePeriodRange = RANGE;
            if (!this.invoicePeriodRangeInitiated) {
                this.invoicePeriodRangeStartMonth = this.getCurrentInvoiceMonthMinusMonths();
                this.invoicePeriodRangeStartYear = this.getCurrentInvoiceYearMinusMonths();
                this.invoicePeriodRangeEndMonth = this.getCurrentInvoiceMonth();
                this.invoicePeriodRangeEndYear = this.getCurrentInvoiceYear();
                this.invoicePeriodRangeInitiated = true;
            }
        },
        getCurrentBookingPeriod() {
            const date = new Date();
            date.setDate(1);
            const key = date.toISOString().split('T')[0];
            return this.getEntryFromObjectArray(this.convertedBookingPeriods, key);
        },
        getCurrentInvoiceMonth() {
            const key = (new Date().getMonth() + 1).toString();
            this.getEntryFromObjectArray(this.convertedInvoiceMonths, key);
            return this.getEntryFromObjectArray(this.convertedInvoiceMonths, key);
        },
        getCurrentInvoiceYear() {
            const key = new Date().getFullYear().toString();
            return this.getEntryFromObjectArray(this.convertedInvoiceYears, key);
        },
        getCurrentInvoiceMonthMinusMonths() {
            const date = new Date();
            let month = date.getMonth() + 1 - RANGE_MINUS_MONTHS;
            if (month <= 0) {
                month = 12 + month;
            }
            return this.getEntryFromObjectArray(this.convertedInvoiceMonths, month.toString());
        },
        getCurrentInvoiceYearMinusMonths() {
            const date = new Date();
            let year = date.getFullYear();
            const month = date.getMonth() + 1 - RANGE_MINUS_MONTHS;
            if (month <= 0) {
                year--;
            }
            return this.getEntryFromObjectArray(this.convertedInvoiceYears, year.toString());
        },
        getEntryFromObjectArray(objectArrayToWalk, keyToCompare) {
            let entry = null;
            objectArrayToWalk.forEach((object) => {
                if (object.key === keyToCompare) {
                    entry = object;
                }
            });
            return entry;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .kgr-inputGroup {
    margin-bottom: 20px;
}
.kgr-table * td {
    padding: 5px;
}
.datePickers {
    margin-bottom: 20px;
}
</style>
